import * as actionTypes from 'constants/actionTypes';
import objectAssign from 'object-assign';
import initialState from './initialState';

export default function shareDialogueReducer(state = initialState.shareDialogue, action) {
  switch (action.type) {
    case actionTypes.OPEN_SHARE_DIALOGUE:
      return objectAssign({}, state, action.newSettings);

    case actionTypes.CLOSE_SHARE_DIALOGUE:
      return objectAssign({}, state, action.newSettings);

    default:
      return state;
  }
}
